/* OxB Noir — vanilla JS, no dependencies */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(cents) {
    var fmt = (window.oxb && window.oxb.moneyFormat) || '£{{amount}}';
    var v = (cents / 100).toFixed(2);
    var withCommas = v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (k === 'amount_with_comma_separator') return v.replace('.', ',');
      return withCommas;
    });
  }

  /* Header: glass on scroll */
  function initHeader() {
    var h = $('[data-oxb-header]');
    if (!h) return;
    var onScroll = function () { h.classList.toggle('is-scrolled', window.scrollY > 40); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    var search = $('[data-oxb-search]');
    $$('[data-oxb-search-open]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!search) return;
        search.hidden = !search.hidden;
        if (!search.hidden) { h.classList.add('is-scrolled'); var i = $('input[type=search]', search); i && i.focus(); }
      });
    });
    $$('[data-oxb-search-close]').forEach(function (b) { b.addEventListener('click', function () { search.hidden = true; }); });

    var mnav = $('[data-oxb-mnav]');
    var opener = $('[data-oxb-menu-open]');
    function setMenu(open) {
      if (!mnav) return;
      mnav.classList.toggle('is-open', open);
      mnav.setAttribute('aria-hidden', open ? 'false' : 'true');
      opener && opener.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (open) { var c = $('[data-oxb-menu-close]', mnav); c && c.focus(); } else { opener && opener.focus(); }
    }
    opener && opener.addEventListener('click', function () { setMenu(true); });
    $$('[data-oxb-menu-close]').forEach(function (b) { b.addEventListener('click', function () { setMenu(false); }); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { if (mnav && mnav.classList.contains('is-open')) setMenu(false); if (search && !search.hidden) search.hidden = true; closeCart(); }
    });
  }

  /* Reveal on scroll */
  function initReveal() {
    var els = $$('[data-oxb-reveal]');
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* Subtle parallax on campaign */
  function initParallax() {
    if (reduce) return;
    var items = $$('[data-oxb-parallax]');
    if (!items.length) return;
    var ticking = false;
    function update() {
      items.forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        var p = (r.top + r.height / 2 - window.innerHeight / 2) / window.innerHeight;
        el.style.transform = 'translate3d(0,' + (p * -6).toFixed(2) + '%,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { requestAnimationFrame(update); ticking = true; } }, { passive: true });
    update();
  }

  /* Page transitions (fade out on internal nav) */
  function initTransitions() {
    if (reduce) return;
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a');
      if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || a.target === '_blank') return;
      if (a.hasAttribute('data-oxb-cart-open')) return;
      var url;
      try { url = new URL(a.href, location.href); } catch (_) { return; }
      if (url.origin !== location.origin || url.hash && url.pathname === location.pathname) return;
      if (/\/(checkout|cart\/|account)/.test(url.pathname)) return;
      e.preventDefault();
      document.body.classList.add('oxb-leaving');
      setTimeout(function () { location.href = url.href; }, 260);
    });
    window.addEventListener('pageshow', function () { document.body.classList.remove('oxb-leaving'); });
  }

  /* Cart drawer */
  var drawer, lastFocus;
  function openCart() {
    drawer = drawer || $('[data-oxb-drawer]');
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    setTimeout(function () { $('.oxb-drawer__panel', drawer).focus(); }, 50);
  }
  function closeCart() {
    drawer = drawer || $('[data-oxb-drawer]');
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    lastFocus && lastFocus.focus && lastFocus.focus();
  }
  function refreshCart(cart) {
    return fetch(window.location.pathname + '?section_id=cart-drawer-lines', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var lines = $('[data-oxb-lines-html]', doc);
        var sub = $('[data-oxb-subtotal-html]', doc);
        var body = $('[data-oxb-drawer-body]');
        if (lines && body) body.innerHTML = lines.innerHTML;
        var subEl = $('[data-oxb-subtotal]');
        if (sub && subEl) subEl.textContent = sub.textContent.trim();
        return cart || fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (c) {
        $$('[data-oxb-cart-count]').forEach(function (b) { b.textContent = c.item_count; b.hidden = c.item_count === 0; });
        $$('[data-oxb-cart-count-inline]').forEach(function (b) { b.textContent = c.item_count; });
        var foot = $('[data-oxb-drawer-foot]');
        if (foot) foot.hidden = c.item_count === 0;
        var bag = $('[data-oxb-cart-open]');
        if (bag) bag.setAttribute('aria-label', 'Bag, ' + c.item_count + ' items');
        return c;
      });
  }
  function initCart() {
    var useDrawer = !window.oxb || window.oxb.cartType !== 'page';
    if (useDrawer) {
      $$('[data-oxb-cart-open]').forEach(function (a) {
        a.addEventListener('click', function (e) { if (window.location.pathname === '/cart') return; e.preventDefault(); openCart(); });
      });
    }
    $$('[data-oxb-cart-close]').forEach(function (b) { b.addEventListener('click', closeCart); });
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-oxb-line-change]');
      if (!btn) return;
      e.preventDefault();
      var body = $('[data-oxb-drawer-body]');
      body && body.classList.add('is-loading');
      fetch((window.oxb && window.oxb.routes.cart_change_url || '/cart/change') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: parseInt(btn.getAttribute('data-oxb-line-change'), 10), quantity: parseInt(btn.getAttribute('data-qty'), 10) })
      }).then(function (r) { return r.json(); })
        .then(function (c) { return refreshCart(c); })
        .finally(function () { body && body.classList.remove('is-loading'); });
    });
  }

  /* Product form: variants, quantity, AJAX add */
  function initProduct() {
    $$('[data-oxb-product]').forEach(function (root) {
      var dataEl = $('[data-oxb-variants]', root);
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var form = $('form.oxb-pform', root);
      if (!form) return;
      var idInput = $('[data-oxb-variant-id]', form);
      var addBtn = $('[data-oxb-add]', form);
      var addLabel = $('[data-oxb-add-label]', form);
      var priceEl = $('[data-oxb-price]', root);
      var stockEl = $('[data-oxb-stock]', root);
      var errEl = $('[data-oxb-error]', form);
      var optionSets = $$('[data-oxb-option]', form);

      function selected() { return optionSets.map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; }); }
      function findVariant(opts) { return variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); }); }

      function markAvailability() {
        var sel = selected();
        optionSets.forEach(function (fs, idx) {
          $$('.oxb-size', fs).forEach(function (lab) {
            var val = $('input', lab).value;
            var test = sel.slice(); test[idx] = val;
            var v = findVariant(test);
            lab.classList.toggle('is-unavailable', !v || !v.available);
          });
        });
      }

      function update() {
        var v = findVariant(selected());
        if (!v) { addBtn.disabled = true; addLabel.textContent = 'UNAVAILABLE'; return; }
        idInput.value = v.id;
        var priceHtml = (v.compare_at_price && v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s> ' : '') + money(v.price);
        if (priceEl) priceEl.innerHTML = priceHtml;
        addBtn.disabled = !v.available;
        addLabel.textContent = v.available ? 'ADD TO BAG — ' + money(v.price) : 'SOLD OUT';
        if (stockEl) stockEl.textContent = v.available ? 'IN STOCK' : 'SOLD OUT';
        markAvailability();
        if (v.featured_media) {
          var fig = $('[data-media-id="' + v.featured_media.id + '"]', root);
          if (fig) {
            var gallery = $('[data-oxb-gallery]', root);
            if (window.innerWidth < 990 && gallery) gallery.scrollTo({ left: fig.offsetLeft, behavior: 'smooth' });
          }
        }
        if (history.replaceState) {
          var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString());
        }
      }
      optionSets.forEach(function (fs) { fs.addEventListener('change', update); });
      if (optionSets.length) markAvailability();

      var qty = $('[data-oxb-qty]', form);
      if (qty) {
        var qi = $('input', qty);
        $$('button', qty).forEach(function (b) {
          b.addEventListener('click', function () { qi.value = Math.max(1, (parseInt(qi.value, 10) || 1) + parseInt(b.dataset.step, 10)); });
        });
      }

      form.addEventListener('submit', function (e) {
        if (window.oxb && window.oxb.cartType === 'page') return;
        e.preventDefault();
        errEl.hidden = true;
        addBtn.disabled = true;
        var prev = addLabel.textContent;
        addLabel.textContent = 'ADDING…';
        var fd = new FormData(form);
        fetch((window.oxb && window.oxb.routes.cart_add_url || '/cart/add') + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
          .then(function (item) {
            document.dispatchEvent(new CustomEvent('cart:add', { detail: { id: item.variant_id, qty: item.quantity } }));
            return refreshCart();
          })
          .then(function () { addLabel.textContent = prev; addBtn.disabled = false; openCart(); })
          .catch(function (err) {
            addLabel.textContent = prev; addBtn.disabled = false;
            errEl.textContent = (err && (err.description || err.message)) || 'Something went wrong. Please try again.';
            errEl.hidden = false;
          });
      });

      /* Mobile gallery dots */
      var gallery = $('[data-oxb-gallery]', root);
      var dots = $$('.oxb-product__dots span', root);
      if (gallery && dots.length) {
        gallery.addEventListener('scroll', function () {
          var i = Math.round(gallery.scrollLeft / gallery.clientWidth);
          dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
        }, { passive: true });
      }
    });
  }

  /* Collection filters */
  function initFilters() {
    var form = $('[data-oxb-filters]');
    if (!form) return;
    var toggle = $('[data-oxb-filter-toggle]', form);
    var panel = $('[data-oxb-filter-panel]', form);
    if (toggle && panel) {
      if (/filter\./.test(location.search)) { panel.hidden = false; toggle.setAttribute('aria-expanded', 'true'); }
      toggle.addEventListener('click', function () {
        panel.hidden = !panel.hidden;
        toggle.setAttribute('aria-expanded', panel.hidden ? 'false' : 'true');
      });
    }
    $$('[data-oxb-autosubmit]', form).forEach(function (el) {
      el.addEventListener('change', function () {
        var params = new URLSearchParams(new FormData(form));
        Array.from(params.keys()).forEach(function (k) { if (params.get(k) === '') params.delete(k); });
        document.body.classList.add('oxb-leaving');
        location.href = form.getAttribute('action') + '?' + params.toString();
      });
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var params = new URLSearchParams(new FormData(form));
      Array.from(params.keys()).forEach(function (k) { if (params.get(k) === '') params.delete(k); });
      location.href = form.getAttribute('action') + '?' + params.toString();
    });
  }

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    initHeader(); initReveal(); initParallax(); initTransitions(); initCart(); initProduct(); initFilters();
    document.addEventListener('shopify:section:load', function () { initReveal(); initProduct(); initParallax(); });
  });
})();
